import { RdModal } from '@/components/readiness/RdModal'

// Toast and confirmation for the evidence archive flow (I5 §13.2); the queue
// and deferred write live in EvidenceArchive.tsx.

export const UNDO_MS = 8000

export function Toast({ title, remaining, onUndo, undoLabel = 'Undo', testId }: { title: string; remaining: number; onUndo: () => void; undoLabel?: string; testId?: string }) {
  return (
    <div className="rd-toast" role="status" data-testid={testId}>
      <span className="min-w-0 flex-1 truncate" title={title}>{title}</span>
      <button type="button" className="rd-link shrink-0 font-semibold" onClick={onUndo} data-testid="archive-undo">{undoLabel}</button>
      <span className="rd-toast-bar" style={{ width: `${Math.max(0, Math.min(100, (100 * remaining) / UNDO_MS))}%` }} aria-hidden="true" />
    </div>
  )
}

// Confirmation only when archiving has consequences (§13.2): the last evidence
// for the current confirmed level, or an item cited in the CSA submission draft.
export type ArchiveConsequence = { kind: 'last_for_level'; level: string } | { kind: 'cited_in_plan'; version: number }

export function ArchiveConfirmModal({ consequences, title, onCancel, onConfirm }: { consequences: ArchiveConsequence[]; title: string; onCancel: () => void; onConfirm: () => void }) {
  return (
    <RdModal title="Archive this evidence?" onClose={onCancel} testId="archive-confirm" footer={<><button type="button" className="rd-btn" onClick={onCancel}>Cancel</button><button type="button" className="rd-btn rd-btn-primary" onClick={onConfirm} data-testid="archive-anyway">Archive anyway</button></>}>
      <p className="mb-2 text-[13px] font-semibold">{title}</p>
      <ul className="space-y-1.5 text-[13px]" style={{ color: 'var(--rd-text-secondary)' }}>
        {consequences.map((c, i) => (
          <li key={i}>{c.kind === 'last_for_level' ? `This is the only evidence for ${c.level}. Without it, saving an assessment will be blocked until evidence is added.` : `This evidence is cited in the CSA submission plan (v${c.version}). Archiving it removes it from the plan's annex.`}</li>
        ))}
      </ul>
    </RdModal>
  )
}
